import React, { useEffect } from "react";
import { useAuth } from "./context/authContext";

const Unauthenticated = () => {
  const { loginUrl } = useAuth();

  useEffect(() => {
    window.location.href = loginUrl;
  }, [loginUrl]);

  return (
    <div
      className={`app`}
      style={{ display: "flex", justifyContent: "center" }}
    >
      <div>
        <h4 style={{ marginBottom: "0" }}>Unauthenticated</h4>
        <p style={{ textAlign: "center" }}>Redirecting to login...</p>
      </div>
    </div>
  );
};

export default Unauthenticated;
